import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { useParentItemsFromSelectedSubItems, useSubItemsFromSelections } from '../../state/selection.state';

import { ToastService } from '../../../../services/toast.service';
import copyIcon from '@ingka/ssr-icon/paths/copy';
import { useCopyParts } from '../../state/copy-parts.state';

export const CopyButton = () => {
   const selectedSubItems = useSubItemsFromSelections();
   const selectedParentItems = useParentItemsFromSelectedSubItems(true)
   const { copyParts, setFamilyName } = useCopyParts()

   const onClick = () => {
      copyParts(selectedSubItems)
      setFamilyName(selectedParentItems[0].familyName)
      ToastService.success(`${selectedSubItems.length} part${selectedSubItems.length > 0 ? 's' : ''} copied`);
   };

   const isAnySelected = selectedSubItems.length > 0;
   const isPartsWithinSameFamily = selectedParentItems.map((item) => item.familyName).reduce((prev, curr, index, list) => {
      if (index > 0) {
         return list[index - 1] === curr
      }

      return prev
   }, true)
   const isAnySelectedItemsBasedOnOther = selectedParentItems.some((item) => item.parentItemNo !== null)
   const isDisabled = !isAnySelected || !isPartsWithinSameFamily || isAnySelectedItemsBasedOnOther;

   const buttonTooltip = () => {
      if (!isAnySelected)
         return 'You need to select part(s) to copy';

      if (!isPartsWithinSameFamily)
         return 'Items of selected parts needs to be within the same family';

      if (isAnySelectedItemsBasedOnOther) {
         return 'One or more selected items is based on some other item and cannot be copied'
      }

      return 'Copy part(s)';
   };

   return (
      <StyledTooltip title={buttonTooltip()}>
         <span>
            <StyledToolbarButton
               ssrIcon={copyIcon}
               text="Filter"
               iconOnly={true}
               small={true}
               onClick={onClick}
               disabled={isDisabled}
            >
            </StyledToolbarButton>
         </span>
      </StyledTooltip>
   );
};